var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeChannelIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "#FC0D1B",
  rx: 10
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.024 8.233c-.142-.92-.567-1.558-1.559-1.7C12.907 6.25 10.5 6.25 10.5 6.25s-2.409 0-3.967.283c-.992.142-1.487.78-1.558 1.7-.142.921-.142 2.267-.142 2.267s0 1.346.142 2.267c.141.92.566 1.558 1.558 1.7 1.558.283 3.967.283 3.967.283s2.408 0 3.966-.283c.992-.213 1.417-.78 1.559-1.7.141-.921.141-2.267.141-2.267s0-1.346-.141-2.267m-6.942 4.392v-4.25l3.542 2.125z"
})));
export default SvgYoutubeChannelIcon;